import { Typography } from "@mui/material";
import React from "react";
import SectionHeader from "./SectionHeader";
import DetailCaption from "./DetailCaption";

function FridayAndSaturday() {
  return (
    <>
      <SectionHeader>Closing Assembly</SectionHeader>
      <DetailCaption>
        The camp buildings are closed for the duration of the Friday night
        assembly.
      </DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>The Friday night assembly will begin at about 6:30 PM.</li>
          <li>
            <b>If you need to get any belongings</b> from any Harmony Hill
            buildings, that must be completed prior to <b>6:00 PM</b> or you
            will have to wait until after the session.
          </li>
          <li>
            <b>If you must leave before the assembly is over,</b> make the
            appropriate arrangements at the office <b>BEFORE</b> the assembly
            begins, and load all your belongings in your vehicle <b>BEFORE</b>{" "}
            the assembly begins.
          </li>
          <li>
            So that Harmony Hill personnel can enjoy the assembly, please stay
            in the assembly until it is complete, including visitors and small
            children. If young children are too restless and need to walk
            around, please keep them close to the assembly, quiet and
            accompanied by an adult.
          </li>
        </ul>
      </Typography>
      <DetailCaption>Friday night schedule</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>On Friday night visiting hours are extended to 10 PM.</li>
          <li>
            All students not in the high school class must go to their sleeping
            areas when visiting hours are over.
          </li>
          <li>
            Students in the high school class are allowed to stay up until
            midnight.
          </li>
          <li>
            At midnight the lights will be turned off and all students and
            adults should retire to their sleeping areas or campsites
          </li>
        </ul>
      </Typography>
      <DetailCaption>Leaving the Hill after Singing School</DetailCaption>
      <Typography variant="body2">
        The school begins with registration on Sunday afternoon, and ends at the
        close of the Friday evening assembly.
        <ul>
          <li>
            Anyone who lives within a two-hour driving distance of Harmony Hill
            is to leave the Hill by 10 PM on Friday.
          </li>
          <li>
            Only those families or individuals who have too far to travel to
            reasonably get home on Friday, or those who will be part of the work
            crew breaking camp and cleaning up on Saturday, are allowed to spend
            Friday night at Harmony Hill.
          </li>
        </ul>
      </Typography>
    </>
  );
}

export default FridayAndSaturday;
